import { languageSelector } from "@omni/ui/components/LanguageSelector/languageSelector.styles";

import { Dropdown } from "@/components/General/Dropdown/dropdown.component";
import { getLabel } from "@/components/General/LanguageSelector/partials/label.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { Config } from "@/utils/config.utils";

import { LanguageSelectorComponentProps } from "../../languageSelector.types";
import { DropdownLanguageItem } from "./drownDownLanguageItem.component";

const LanguageDropDownSelector = ({
    variant,
    color
}: LanguageSelectorComponentProps) => {
    const { t } = useGranite();

    const currentLanguage = Config.languages.find(
        (language) => language.locale === Config.general.locale
    );

    const label = getLabel({
        language: currentLanguage,
        variant: variant,
        t: t
    });

    return (
        <Dropdown
            placement={"bottom"}
            isLabel={true}
        >
            <Dropdown.Toggle
                color={"transparent"}
                className={languageSelector({
                    layout: "default",
                    color: color
                })}
            >
                <Dropdown.Label>{label}</Dropdown.Label>
                <Dropdown.Caret />
            </Dropdown.Toggle>
            <Dropdown.Menu>
                {Config.languages.map((language) => (
                    <DropdownLanguageItem
                        key={language["language-code"]}
                        language={language}
                        isDisabled={language.locale === Config.general.locale}
                        variant={variant}
                    />
                ))}
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default LanguageDropDownSelector;
